const data = [{
    'DisplayPlan':{true: true, false: true},
    'Title':{FR: 'Régulier', EN: 'Regular Service'},
    'DisplayButton':{true: false, false: false},
    'PlanTemplate':'EndUser_000_V02P00',
    'PlanPricing':{true:0,false:0},
    'Description':[{'text1':{FR: 'Historique de consultation :', EN: 'Data historic :'},
                    'text2':{FR: '1 an', EN: '1 year'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: "Niveau d'alerte:", EN: 'Available alert level:'},
                    'text2':{FR: 'Niveau 1', EN: 'Level 1'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Alerte configurable :', EN: 'Configurable alert :'},
                    'text2':{FR: '1 par port, 3 par module', EN: '1 per port, 3 per module'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Alerte email maximum :', EN: 'Maximum email alert :'},
                    'text2':{FR: '50', EN: '50'},
                    'text3':{FR: 'par mois', EN: 'per month'}},
                    {'text1':{FR: 'Rapport hebdomadaire', EN: 'Weekly report:'},
                    'text2':{FR: 'Simplifié', EN: 'Simple'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Plateforme pour véhicule électrique', EN: 'Electric vehicle platform'},
                    'text2':{FR: '', EN: ''},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Garantie sur le matériel', EN: 'Material warranty'},
                    'text2':{FR: '1 an', EN: '1 year'},
                    'text3':{FR: '', EN: ''}},
                    ],
    },

    {
    'DisplayPlan':{true: true, false: true},
    'Title':{FR: 'Client Premium', EN: 'Premium Customer'},
    'DisplayButton':{true: true, false: true},
    'PlanTemplate':'EndUser_030_V02P00',
    'PlanPricing':{true:'60',false:'8'},
    'Description':[{'text1':{FR: 'Historique de consultation :', EN: 'Data historic :'},
                    'text2':{FR: 'illimité', EN: 'unlimited'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: "Niveau d'alerte:", EN: 'Available alert level:'},
                    'text2':{FR: 'Niveau 2', EN: 'Level 2'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Alerte configurable :', EN: 'Configurable alert :'},
                    'text2':{FR: 'illimité', EN: 'unlimited'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Alerte email maximum :', EN: 'Maximum email alert :'},
                    'text2':{FR: 'illimité', EN: 'unlimited'},
                    'text3':{FR: 'par mois', EN: 'per month'}},
                    {'text1':{FR: 'Alerte SMS :', EN: 'SMS alert :'},
                    'text2':{FR: '100', EN: '100'},
                    'text3':{FR: 'max par mois', EN: 'max per month'}},
                    {'text1':{FR: 'Rapport hebdomadaire', EN: 'Weekly report'},
                    'text2':{FR: 'avec comparatif semaines précédentes', EN: 'with last weeks comparison'},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Données météo :', EN: 'Weather data :'},
                    'text2':{FR: 'température, vent, humidité, ennuagement', EN: 'temperature, wind, humidity, cloud'},
                    'text3':{FR: 'enregistrés aux heures', EN: 'hourly recorded'}},
                    {'text1':{FR: 'Plateforme pour véhicule électrique', EN: 'Electric vehicle platform'},
                    'text2':{FR: '', EN: ''},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: "Tableau des données de mesure", EN: 'Measurement data table'},
                    'text2':{FR: '', EN: ''},
                    'text3':{FR: '(copiez vos données dans Excel)', EN: '(copy your data in Excel)'}},
                    {'text1':{FR: "Émission d'alerte courriel vers d'autres usagers EV Sens", EN: 'Alert transmission to other EV Sens users'},
                    'text2':{FR: '', EN: ''},
                    'text3':{FR: '', EN: ''}},
                    {'text1':{FR: 'Garantie sur le matériel', EN: 'Material warranty'},
                    'text2':{FR: "pour la durée de l'abonnement Premium", EN: 'for the entire Premium subscription'},
                    'text3':{FR: '', EN: ''}},
                    ],
    },

                
]
export default data;



// WEBPACK FOOTER //
// ./src/views/profile/UserPlanDescriptions.js